import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import {LOBBY_PAGE} from '../../../../themes/css-global-classes';


const DefaultBox = styled.div`
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const PcBox = DefaultBox;

export const MobileBox = styled(DefaultBox)`
    .${LOBBY_PAGE} & {
        padding: 0 1rem;
    }
`;

export const GamesGridDefaultBox = styledByDevice(PcBox, MobileBox);